import axios from "axios";
import server_config from '../ServerConfiguration';

const fevir_node_server_address = server_config["fevir_node_server_address"];

const submitNctid = async (nctid = null, apiToken = null) => {
    if (!nctid) {
        console.log("no nctid");
        return null;
    }
    console.log("CALLING SERVER with submitnctid")
    return await axios({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            'functionid': 'submitnctid',
            'apiToken': apiToken,
            'tool': "ctgovtofhirconverter",
            'nctid': nctid || "",
            'addtodatabase': true,
            'status': "active",
        },
    }).then((resp) => {
        if (resp?.data) {
            return resp.data;
        }
        console.log("NO RESPONSE from submitnctid call");
    }).catch((error) => { console.log(error); });
};

const submitNctidsFromSearch = async (querySearchTypes = null, aggFilters, apiToken = null,
     filterOverallStatus) => {
        if (!querySearchTypes) {
        console.log("no querySearchTypes");
        return null;
    }
    console.log("CALLING SERVER with addnctidsfromctgovsearch")
    return await axios({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            'functionid': 'addnctidsfromctgovsearch',
            'apiToken': apiToken,
            "querySearchTypes": querySearchTypes,
            "getSearchResults": true,
            "filterOverallStatus": filterOverallStatus,
            "aggFilters": aggFilters
        },
    }).then((resp) => {
        if (resp?.data) {
            return resp.data;
        }
        console.log("NO RESPONSE from addnctidsfromctgovsearch call");
    }).catch((error) => { console.log(error); });
};

export default submitNctid;
export { submitNctidsFromSearch };